/**
 * CallSync's WhatsApp number, with the country code and no "+". The website,
 * Help Center and dashboard all link here; change it once, then rebuild and
 * deploy all three.
 */
export const SUPPORT_WHATSAPP = '919138331357';

/** A WhatsApp chat link to CallSync, optionally with a pre-filled message. */
export function whatsappLink(text?: string): string {
  return `https://wa.me/${SUPPORT_WHATSAPP}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}
